import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
import { RouterModule, Routes, NavigationEnd, ActivatedRoute, Router } from '@angular/router';
import { AuthGaurdService } from "./service/auth-gaurd.service";
//import { HomeComponent } from './component/home/home.component';
import { HomepageComponent } from './component/homepage/homepage.component';
import { SharedModule } from './shared/shared.module';
import { UsersComponent } from './users/users.component';

import { AccountComponent } from './component/account/account.component';
import { PostComponent } from './component/activity-feed/post/post.component'
import { SettingsHeaderComponent } from './component/settings-header/settings-header.component';
import { SettingsComponent } from './component/settings/settings.component';
import { NotificationsComponent } from './component/settings/notifications/notifications.component';
import { MybuildingComponent } from './component/settings/mybuilding/mybuilding.component';
import { MessageComponent } from "./component/message/message.component";
// import { MessageGroupsComponent } from "./component/message-groups/message-groups.component";
import { ChatComponent } from './component/chat/chat.component';
import { GroupsComponent } from "./component/groups/groups.component";
import { CreategroupComponent } from './component/groups/creategroup/creategroup.component';
import { MessagesHeaderComponent } from './component/messages-header/messages-header.component';
import { AllgroupsComponent } from './component/groups/allgroups/allgroups.component';
import { CommentsComponent} from "./component/activity-feed/post/comments/comments.component";
import { TimeAgoPipe} from "time-ago-pipe";
import { ReplyComponent} from "./component/activity-feed/post/comments/reply/reply.component";
import { RouterResolverService } from "./service/router-resolver.service";
import { AuthServiceAuthenticatedUsersService } from "./service/auth-service-authenticated-users.service";
import { ThankyouComponent} from "./component/thankyou/thankyou.component";
import { LoadingComponent} from "./component/loading/loading.component";
import { ConvertHTMLPipe } from './pipe/convert-html.pipe';
import { AlertsComponent} from "./component/building/alerts/alerts.component";
import { EventsComponent } from './component/events/events.component';
import { ResidentListComponent} from "./component/resident/resident-list/resident-list.component";
import { UserAccountSettingsComponent} from "./component/settings/user-account-settings/user-account-settings.component";
import { CheckboxStatusPipePipe } from './pipe/checkbox-status-pipe.pipe';
import { BuildingsComponent } from './component/building/buildings/buildings.component';
import { userSearchPipe } from "./pipe/userSearchPipe";
import { PaymentSettingsComponent } from './component/settings/payment-settings/payment-settings.component';
import { InviteComponent } from './component/invite/invite.component';
import { DocumentsComponent } from './component/documents/documents.component';
import { PromocodeComponent } from './component/settings/promocode/promocode.component';
import { AttendancePipe } from './pipe/attendance.pipe';
import { MaintenanceCheckPipe } from './pipe/maintenance-check.pipe';
import { AddressPipe } from "./pipe/address.pipe";
import { BaseurlPipe } from './pipe/baseurl.pipe';
import { MomentModule } from "angular2-moment";
import { GroupFilterPipe } from './pipe/group-filter.pipe';
import { ManagerBuildingAddressFormatPipe } from './pipe/manager-building-address-format.pipe';
import { AttendStylePipe } from './pipe/attend-style.pipe';
import { RemoveImagePipe } from './pipe/remove-image.pipe';
import { ClickOutsideDirective } from './directive/click-outside.directive';
import { Ng2OrderModule } from "ng2-order-pipe";
import { Meta, Title } from '@angular/platform-browser';

import { CloseDropdownDirective } from './directive/close-dropdown.directive';
import { ImageLoadingComponent } from './component/image-loading/image-loading.component';
import { PostFlagPipe } from './pipe/post-flag.pipe';
import { nl2brPipe } from "./pipe/nl2brPipe";
import { TwitterContentPipe } from './pipe/twitter-content.pipe';
import { AddressSearchBarComponent } from './component/address-search-bar/address-search-bar.component';
import { ReportToMycoopComponent } from './component/report-to-mycoop/report-to-mycoop.component';
import { PricingComponent } from './component/pricing/pricing.component';
import { ProductComponent } from './component/product/product.component';
import { AddtocalendarComponent } from './component/addtocalendar/addtocalendar.component';
import { CreatebuildingComponent } from './component/createbuilding/createbuilding.component';
import { PromoStatusPipe } from './pipe/promo-status.pipe';
import { ErrorComponent } from './component/error/error.component';
import { UpgradeSuccess } from './component/accountUpgradeSuccess/thankyou.component'
import { environment } from '../environments/environment';
import {AboutUsComponent} from "./component/about-us/about-us.component";
import { filter, map, mergeMap } from 'rxjs/operators';


const routes: Routes = [
  //{ path: '', component: HomeComponent, canActivate: [AuthServiceAuthenticatedUsersService] },
  { path: '', component: HomepageComponent, canActivate: [AuthServiceAuthenticatedUsersService],
     data: { title: 'Mycoop - Simple Building Communication Platform | Digital Platform for Apartment Buildings', metaDescription: 'Mycoop is a simple building communication platform that has revolutionized residential building communications and helps develop deeper resident relationships. Learn more about the software at our website.' }},
  { path: 'feed', component: PostComponent, canActivate: [AuthGaurdService] },
  { path: 'dqmrbpxxmobqk', component: CreatebuildingComponent },
  { path: 'account/verify', component:AccountComponent },
  { path: 'account/verifyuser', component:AccountComponent },
  { path: 'user', component: UsersComponent},
  { path: 'user/:id', component: UsersComponent},
  { path: 'user/settings/account', component: UserAccountSettingsComponent},
  { path: 'building', loadChildren : './component/resident/resident.routing#ResidentRoutingModule' },
  { path : 'buildings/alerts', component : AlertsComponent, canActivate: [AuthGaurdService]},
  { path : 'buildings', component : BuildingsComponent, canActivate: [AuthGaurdService]},
  { path : 'buildings/:buildingId/alerts', component : AlertsComponent, canActivate: [AuthGaurdService]},
  { path : 'allbuildings', component : BuildingsComponent, canActivate: [AuthGaurdService] },
  { path: 'managerprofile', loadChildren: './component/building-manager/building-manager.routing#BuildingManagerRoutingModule'},
  { path : 'messages', component : MessageComponent, canActivate: [AuthGaurdService] },
  { path : 'groups', component : GroupsComponent, canActivate: [AuthGaurdService]},
  { path : 'allgroups', component : AllgroupsComponent, canActivate: [AuthGaurdService]},
  { path : 'thankyou', component : ThankyouComponent},
  { path : 'residents', component : ResidentListComponent},
  { path: 'documents', component: DocumentsComponent, canActivate: [AuthGaurdService] },
  { path : 'settings', component : SettingsComponent, canActivate: [AuthGaurdService]},
  { path : 'user/settings/notifications', component : NotificationsComponent, canActivate: [AuthGaurdService]},
  { path : 'user/settings/mybuilding', component : MybuildingComponent, canActivate: [AuthGaurdService]},
  { path : 'user/settings/payment', component: PaymentSettingsComponent, canActivate: [AuthGaurdService] },
  { path: 'user/settings/promocode', component: PromocodeComponent, canActivate: [AuthGaurdService] },
  { path : 'upgradesuccess', component : UpgradeSuccess},
  { path: 'pricing', component: PricingComponent,
    data: { title: 'mycoop | Pricing | Love Where You Live - simple building communication', metaDescription: 'Choose the best plan that suits your buildings need.' }},
  { path: 'product', component: ProductComponent,
  data: { title: 'Mycoop – Features | Residential Communication Software for Apartment Buildings', content: 'hello', metaDescription: 'mycoop is a property management software designed to assist with property and tenant relationship management. Visit our website today to learn more about mycoop.' } },
  {path: 'about-us', component: AboutUsComponent, data: {title: 'mycoop | About Us | Love Where You Live - simple building communication'}},
  {path : '**' , component : ErrorComponent},
];

@NgModule({
  declarations: [
   // HomeComponent,
    // HomepageComponent,
    // UsersComponent,
    // AccountComponent,
    // SettingsHeaderComponent,
    // SettingsComponent,
    // NotificationsComponent,
    // MybuildingComponent,
    // MessagesHeaderComponent,
    // MessageComponent,
    // ChatComponent,
    // GroupsComponent,
    // CreategroupComponent,
    // AllgroupsComponent,
    // PostComponent,
    // CommentsComponent,
    // ReplyComponent,
    // TimeAgoPipe,
    // ThankyouComponent,
    // ConvertHTMLPipe,
    // AlertsComponent,
    // EventsComponent,
    // ResidentListComponent,
    // UserAccountSettingsComponent,
    // CheckboxStatusPipePipe,
    // BuildingsComponent,
    // userSearchPipe,
    // PaymentSettingsComponent,
    // InviteComponent,
    // DocumentsComponent,
    // PromocodeComponent,
    // AttendancePipe,
    // MaintenanceCheckPipe,
    // AddressPipe,
    // BaseurlPipe,
    // AddressPipe,
    // GroupFilterPipe,
    // ManagerBuildingAddressFormatPipe,
    // AttendStylePipe,
    // RemoveImagePipe,
    // ClickOutsideDirective,
    // CloseDropdownDirective,
    // ImageLoadingComponent,
    // PostFlagPipe,
    // nl2brPipe,
    // TwitterContentPipe,
    // AddressSearchBarComponent,
    // PricingComponent,
    // ReportToMycoopComponent,
    // ProductComponent,
    // AddtocalendarComponent,
    // CreatebuildingComponent
  ],
  imports: [
    RouterModule.forRoot(
      routes
    ),
    Ng2OrderModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      //apiKey: 'AIzaSyDUU3-MYDOb2qEF1Sq1nSb96BoBeB-4JmE',
      //apiKey: 'AIzaSyCAoEm8t7wFhb2Bm0QCRsHzp8i3kxZ4UVo',
      libraries: ['places']
    }),

  ],
  exports : [
      RouterModule,
      // ChatComponent,
      // EventsComponent,
  ],
  providers: [userSearchPipe],
})
export class AppRoutingModule {


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta
  ) {
    // Boilerplate code to filter out only important router events and to pull out data object field from each route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    ).subscribe(event => {
      const defaultTitle = 'mycoop | Love Where You Live - simple building communication';
      const defaultMetaDescription = 'Mycoop is a simple building communication platform that has revolutionized residential building communications and helps develop deeper resident relationships. Learn more about the software at our website.';
      const title = event.title || defaultTitle;
      const tag = { name: 'description', content: event.metaDescription || defaultMetaDescription };
  
      if (title) {
        this.titleService.setTitle(title);
      }
  
      if (tag.content) {
        this.metaService.updateTag(tag);
      }
    });
  }

 }
